var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
      	numberFilterTree: 2
    }
};
// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' product-price--sold-out grid-view-item--sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<label class="sold-out"><span>' + bcSfFilterConfig.label_basic.sold_out + '</span></label>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
    'vendorHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
    // Grid Template
    'productGridItemHtml': '<div class="grid__item {{itemGridWidthClass}}">' +
                                '<div class="grid-view-item {{soldOutClass}} wow fadeIn" data-wow-delay="{{delay_time}}ms">' +
                                    '<div class="grid-view_image">' +
                                        '<a class="grid-view-item__link" href="{{itemUrl}}">' +
                                            '{{itemImages}}' +
                                            '<i class="ad ad-circle-o-notch ad-spin loading"></i>' +
                                            '<img src="" class="grid-view-item__image hover variantImg" alt="" />' +
                                            '{{itemLabels}}' +
                                        '</a>' +
                                        '{{itemButton}}' +
                                    '</div>' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div class="h4 grid-view-item__title">{{itemTitle}}</div>' +
  										'<div class="loox-rating" data-id="{{itemId}}" data-fetch></div>' +
                                        '{{itemVendor}}' +
                                        '<div class="grid-view-item__meta">' +
                                            '{{itemPrice}}' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
                            '</div>',
    // For List View
    // List Template
    'productListItemHtml':  '<a class="list-view-item wow fadeInUp" data-wow-delay="{{delay_time}}ms">' +
                              '<div class="list-view-item__image-column">' +
                                '<div class="list-view-item__image-wrapper">' +
                                  '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                  '{{itemLabels}}' +
                                '</div>' +
                              '</div>' +
                              '<div class="list-view-item__title-column">' +
                                '<div class="h4 grid-view-item__title">{{itemTitle}} </div>' +
  								'<div class="loox-rating" data-id="{{itemId}}" data-fetch></div>' +
                                '<p>{{itemDescription}}</p>' +
                                '<p class="grid-view-item__meta">{{itemPrice}}</p>' +
                                '{{itemButton}}' +
                              '</div>' +
                            '</a>',
    // End For List View
    // Pagination Template
    'previousActiveHtml': '<li class="prev"><a href="{{itemUrl}}"><i class="fa fa-caret-left" aria-hidden="true"></i></a></li>\n',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}"><i class="fa fa-caret-right" aria-hidden="true"></i></a></li>\n',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>\n',
    'pageItemSelectedHtml': '<li class="active"><a href="#">{{itemTitle}}</a></li>\n',
    'pageItemRemainHtml': '<li class="ellipsis disabled"><a href="{{itemUrl}}">{{itemTitle}}</a></li>\n',
    'paginateHtml': '<div class="pagination"><ul>{{previous}}{{pageItems}}{{next}}</ul></div>',
    // Sorting Template
    'sortingHtml': '<label for="SortBy" class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select name="SortBy" id="SortBy" class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add a specific class for grid item
  var itemGridWidthClass = bcSfFilterConfig.custom.grid_item_ds + ' ' + bcSfFilterConfig.custom.grid_item_tb + ' ' + bcSfFilterConfig.custom.grid_item_mb;
  itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

  // Add item button
  var itemButtonHtml = '';
  if (soldOut) {
    itemButtonHtml += '{{itemSoldOut}}';
  } else {
    if (bcSfFilterConfig.custom.show_cart_btn) {
      itemButtonHtml += '<form class="variants add" action="/cart/add" method="post">';
      if (!soldOut) {
        if (data.variants.length > 1) {
          itemButtonHtml += '<button class="btn btn--secondary btn-addto-cart" type="button" onclick="window.location.href=\'{{itemUrl}}\'">' + bcSfFilterConfig.label.select_option + '</button>';
        } else {
          itemButtonHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
          itemButtonHtml += '<button type="button" id="' + firstVariant.id + '" rel="1" class="btn--secondary add-to-cart">' + bcSfFilterConfig.label.add_to_cart + '</button>';
        }
      }
      itemButtonHtml += '</form>';
    }
    itemButtonHtml += '<div class="button-set">';
    if (bcSfFilterConfig.custom.quick_view) {
      itemButtonHtml += '<a href="{{itemUrl}}?view=quick_view" title="' + bcSfFilterConfig.label.quick_view + '" class="quick-view"><i class="ad ad-search-plus-r"></i></a>';
    }
    if (bcSfFilterConfig.custom.wishlist) {
      itemButtonHtml += '<div class="wishlist-btn">' + 
                          '<a class="wishlist add-to-wishlist" href="{{itemHandle}}" rel="{{itemHandle}}" title="' + bcSfFilterConfig.label.add_to + '"><i class="ad ad-heart-l"></i> <span>' + bcSfFilterConfig.label.add_to + '</span></a>' +
                          '<a class="wishlist loading-wishlist" href="{{itemHandle}}"><i class="ad ad-spinner4 ad-spin"></i></a>' +
                          '<a class="wishlist added-wishlist" href="/pages/wishlist" rel="{{itemHandle}}" title="' + bcSfFilterConfig.label.wishlist_available + '"><i class="ad ad-heart"></i> <span>' + bcSfFilterConfig.label.wishlist_view + '</span></a>' +
                        '</div>';
    }
    itemButtonHtml += '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemButton}}/g, itemButtonHtml);

  // Add sold out
  itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, bcSfFilterTemplate.soldOutLabelHtml);

  // Add Price
  var itemPriceHtml = '';
  if (onSale) {
      if (priceVaries) {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
          itemPriceHtml += '<span class="product-price__price product-price__sale">';
          itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
          itemPriceHtml += '</span>';
      } else {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
          itemPriceHtml += '<span class="product-price__price product-price__sale">';
          itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      }
  } else {
      if (priceVaries) {
          itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      } else {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      }
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);


  // Add delay time
  itemHtml = itemHtml.replace(/{{delay_time}}/g, 50 * index);
  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data, index) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  
  // Add Images
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, thumbUrl);
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = '';
  if (onSale) {
      if (priceVaries) {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
          itemPriceHtml += '<span class="product-price__price product-price__sale">';
          itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
          itemPriceHtml += '</span>';
      } else {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<s class="product-price__price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s>';
          itemPriceHtml += '<span class="product-price__price product-price__sale">';
          itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      }
  } else {
      if (priceVaries) {
          itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      } else {
          itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
          itemPriceHtml += '<span class="product-price__price">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
      }
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Add sold out
  itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, bcSfFilterTemplate.soldOutLabelHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

  //Add item button
  var itemButtonHtml = '';

  itemButtonHtml += '<form class="variants" action="/cart/add" method="post">';
  if (!soldOut) {
    if (data.variants.length > 1) {
      itemButtonHtml += '<button class="btn btn--small" type="button" onclick="window.location.href=\'{{itemUrl}}\'">' + bcSfFilterConfig.label.select_option + '</button>';
    } else {
      itemButtonHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
      itemButtonHtml += '<button type="button" id="' + firstVariant.id + '" rel="1" class="btn--secondary add-to-cart">' + bcSfFilterConfig.label.add_to_cart + '</button>';
    }
    itemButtonHtml += '</form>';
  }
  itemHtml = itemHtml.replace(/{{itemButton}}/g, itemButtonHtml);

  // Add delay time
  itemHtml = itemHtml.replace(/{{delay_time}}/g, 100 * index);

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildImages(data) {
  var html = '';
  var images = data.images_info;
  // Build Main Image
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '150x') : bcSfFilterConfig.general.no_image_url;
  var img_url =  images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '{width}x') : bcSfFilterConfig.general.no_image_url;
  var aspect_ratio = images.length > 0 ? images[0]['width'] / images[0]['height'] : 1;
  var primary = images.length > 1 ? 'primary': '';
  //html += '<img src="' + thumbUrl + '" class="bc-sf-filter-product-item-main-image" />';
  html += '<img class="grid-view-item__image lazyload ' + primary + '" src="' + thumbUrl + '" ' + 
            'data-src="' + img_url + '" data-widths="[180, 360, 540, 720, 900, 1080]" ' +
            'data-aspectratio="' + aspect_ratio + '" data-sizes="auto" alt="{{itemTitle}}"' +
          '>';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap && images.length > 1) {
    var img_url1 =  bcsffilter.optimizeImage(images[1]['src'], '{width}x');
    var aspect_ratio1 = images[1]['width'] / images[1]['height'];
    var flipImageUrl = bcsffilter.optimizeImage(images[1]['src'], '150x');
    html += '<img class="grid-view-item__image lazyload hover" src="' + flipImageUrl + '" ' +
              'data-src="' + img_url1 + '" data-widths="[180, 360, 540, 720, 900, 1080]" ' +
              'data-aspectratio="' + aspect_ratio1 + '" data-sizes="auto" alt="{{itemTitle}}"' +
            '>';
  }
  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}


function buildLabels(data) {
  var html = '';
  var onSale = data.compare_at_price_min > data.price_min;
  var newLabel = bcSfFilterConfig.custom.pr_label1;
  var hotLabel = bcSfFilterConfig.custom.pr_label2;
  var popularLabel = bcSfFilterConfig.custom.pr_label3;
  
  if (bcSfFilterConfig.custom.pr_lbl) {
    html += '<div class="product-labels ' + bcSfFilterConfig.custom.select_label_style + '">';
    if (onSale && bcSfFilterConfig.custom.sale_lbl) {
      if (bcSfFilterConfig.custom.sale_label_style == 'salelabel') {
        html += '<label class="lbl on-sale">' + bcSfFilterConfig.label_basic.sale + '</label>';
      } else {
        html += '<label class="lbl on-sale">-' + data.percent_sale_min + '%</label>';
      }
    }
    if (data.tags.indexOf(newLabel) !== -1) {
      html += '<label class="lbl pr-label1">' + newLabel + '</label>';
    }
    if (data.tags.indexOf(hotLabel) !== -1) {
      html += '<label class="lbl pr-label2">' + hotLabel + '</label>';
    }
    if (data.tags.indexOf(popularLabel) !== -1) {
      html += '<label class="lbl pr-label3">' + popularLabel + '</label>';
    }
    html += '</div>';
  }
  return html;
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><img src="' + bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', 'grid.jpg') + '"></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><img src="' + bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', 'list.jpg') + '"></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('change-view--active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('change-view--active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('change-view--active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  $(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('collection-template', theme.Filters);
    sections.register('collection-template', theme.collectionView);
    $(theme.ajaxCart);
  });
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
  var to = from + data.products.length - 1;
  var totalProduct = bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  bcSfFilterConfig.label.pagination_of + ' ' + data.total_product;
  if (data.total_product == 1) {
    totalProduct = bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  bcSfFilterConfig.label.pagination_of + ' ' + data.total_product;
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  if (this.queryParams.display == 'list') {
    jQ('#bc-sf-filter-products').removeClass('grid grid-products grid--view-items');
    jQ('#bc-sf-filter-products').addClass('list-view-items');
  } else {
    jQ('#bc-sf-filter-products').addClass('grid grid-products grid--view-items');
    jQ('#bc-sf-filter-products').removeClass('list-view-items');
  }
};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; } return data };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
